import { Component, OnInit } from '@angular/core';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentUser:User;
  constructor(private authUser: AuthUserService) { }

  ngOnInit() {
    this.currentUser = this.authUser._user;
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/footer/footer.component.ts